/* eslint-disable no-param-reassign */
/* eslint-disable class-methods-use-this */
import { GetterTree, MutationTree, ActionTree } from 'vuex';
import BaseModule from '../module';
import { State, RootState } from '../types';

interface OidcRegisterState extends State {
  sub: string;
  showVwBnPMappingDialogue: boolean;
  vwBnPMappingDialogueSuccess: boolean;
}

class OidcRegisterModule extends BaseModule<OidcRegisterState> {
  protected initialState(): OidcRegisterState {
    return {
      sub: '',
      showVwBnPMappingDialogue: false,
      vwBnPMappingDialogueSuccess: false,
    }
  }

  protected buildGettersTree(): GetterTree<OidcRegisterState, RootState> {
    return {
      sub: (state) => state.sub,
      subSet: (state) => state.sub.length > 0,
      showVwBnPMappingDialogue: (state) => state.showVwBnPMappingDialogue,
      vwBnPMappingDialogueSuccess: (state) => state.vwBnPMappingDialogueSuccess,
    }
  }

  protected buildMutationsTree(): MutationTree<OidcRegisterState> {
    return {
      changeSub(state, newSub) {
        state.sub = newSub
      },
      setShowVwBnPMappingDialogue: (state, value) => {
        state.showVwBnPMappingDialogue = value;
      },
      setVwBnPMappingDialogueSuccess: (state, value) => {
        state.vwBnPMappingDialogueSuccess = value;
      },
    }
  }

  protected buildActionsTree(): ActionTree<OidcRegisterState, RootState> {
    return {
      setSubTo(context, sub: string) {
        context.commit('changeSub', sub);
      },
    }
  }
}

export default new OidcRegisterModule(true);
